import httpClient from './httpClient';

export const login = async (credentials) => {
  const { data } = await httpClient.post('/auth/login', credentials);
  return data;
};

export const fetchProfile = async () => {
  const { data } = await httpClient.get('/auth/me');
  return data;
};

export const updateProfile = async (payload) => {
  const { data } = await httpClient.put('/auth/me', payload);
  return data;
};



